import { createContext } from "react";

const MpDataContext = createContext({});

export default MpDataContext;